<template>
  <el-container>
    <el-header>
      <el-menu
        style="height: 100%"
        default-active="/exterior"
        mode="horizontal"
        background-color="#baa364"
        text-color="#fff"
        active-text-color="#fff"
      >
        <el-menu-item index="/exterior">
          关于我们
        </el-menu-item>
      </el-menu>
      <div class="logo"><img src="@/assets/imgs/lo.png" alt="" /><span>轻松集团</span></div>
    </el-header>
    <img class="top-img" src="@/assets/imgs/index-top.png" alt="">
    <el-main style="padding: 0">
      <div class="my">
    <div class="my-title">关于我们</div>
      <div class="my-box">
        <div class="my-box-left">
          <img src="@/assets/imgs/my-img.png" alt="">
        </div>
        <div class="my-box-right">
          <div class="my-box-right-title">深圳市轻松集团</div>
          <p class="my-box-right-text">深圳轻松由一支热爱并高度理解的音乐软件开发服务专业团队组成，拥有音乐软件开发领域实战经验，百余人专业团队，以不拘一格的人才战略和综合的资源体系运作，高度践行集团战略，助力客户价值升级。</p>
          <p class="my-box-right-text">深圳市轻松集团，以高度的战略格局和敏锐的商业嗅觉，专注于为客户提供音乐移动互联网软件定制开发服务。业务范围涵盖软件开发、应用软件定制、微信开发、产品设计规划等专业服务。</p>
        </div>
      </div>
  </div>
    </el-main>
    <el-footer style="height: 100%">
      <div class="bottom-message">
        <p>@深圳市轻松集团</p>
        <p>电话：0755-36640500</p>
        <p>地址：广东省深圳市龙华区龙华街道松和社区东环一路108号油松科技大厦B栋3层B322</p>
      </div>
      <div class="bottom-copyright">
        <p><a href="https://beian.miit.gov.cn" target="_blank" >备案号：粤ICP备18069072号</a></p>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
    }
  },
}
</script>
<style scoped>
.el-container {
  position: relative;
}
.el-header {
  width: 100%;
  padding: 0 360px;
  background-color: #baa364;
  align-items: center;
  display: flex;
}
.el-header img {
  width: 100%;
  height: 100%;
}
.logo {
  width: 270px;
  height: 40px;
  margin: 0 auto;
  display: flex;
}
.logo img {
  width: 50px;
  height: 35px;
}
.logo span {
  font-size: 24px;
  font-weight: 700;
  line-height: 35px;
  margin-left: 8px;
  color: #fff;
}

.top-img {
  width: 100%;
  height: 100%;
}
.index-text {
  position: absolute;
  top: 200px;
  left: 360px;
  line-height: 59px;
  color: #fff;
  font-weight: bold;
}
.index-text-top {
  font-size: 36PX;
}
.index-text-bottom {
  font-size: 24PX;
}

.el-footer {
  width: 100%;
  padding: 34px 360px;
  color: #fff;
  background-color: #baa364;
  
}
.bottom-message {
  font-size: 18PX;
  line-height: 30px;
  margin-bottom: 20px;
}
.bottom-copyright {
  font-size: 18PX;
  line-height: 24px;
}
.my {
  width: 100%;
  height: 100%;
  padding: 0 360px;
}
.my-title {
  font-size: 24PX;
  line-height: 59px;
  margin-top: 30px;
  border-bottom: 2px #BAA364 solid;
  margin-bottom: 60px;
}
img {
  width: 100%;
  height: 100%;
}
.my-box {
  width: 100%;
  margin-bottom: 100px;
  display: flex;
  justify-content: space-between;
}
.my-box-left {
  width: 50%;
}
.my-box-right {
  width: 50%;
  padding: 40px 30px;
  background-color: #F3F3F3;
}
.my-box-right-title {
  font-size: 30px;
  line-height: 30px;
  margin-bottom: 45px;
}
.my-box-right-text {
  font-size: 18PX;
  line-height: 30px;
  text-indent: 2rem;
  margin-bottom: 10px;
  text-align: justify;
}
</style>
